import dynamic from 'next/dynamic';
export const HubspotForm = dynamic(() => import('./HubspotForm'));
export { default } from './HubspotForm';
